export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Viernes_eng_scroll.aa5beb18.png";